import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      step: 7
      // tradeType: ''
    };
  },
  computed: {
    ...mapGetters([
      'processList',
      'tradeType'
    ])
  },
  created () {
    // this.tradeType = this.$route.query.tradeType;
    if (this.tradeType === '2') {
      // this.processList = ['业务流程及准备材料', '编辑项目信息', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'];
      this.step = 4;
    }
    if (this.tradeType === '3') {
      this.step = 4;
    }
  },
  methods: {
    goToList () {
      if(this.tradeType === '3') {
        this.$router.push('/person-center/project/batch-out-project/list');
      } else {
        this.$router.push('/person-center/project/roll-out-project/list');
      }
    }
  }
};
